import { render, staticRenderFns } from "./testListNew.vue?vue&type=template&id=87e7e4ec&scoped=true&"
import script from "./testListNew.vue?vue&type=script&lang=js&"
export * from "./testListNew.vue?vue&type=script&lang=js&"
import style0 from "./testListNew.vue?vue&type=style&index=0&id=87e7e4ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e7e4ec",
  null
  
)

export default component.exports